<ng-template #commentPartial let-comment let-index="index">
  <article class="comment" [class.comment-reply]="index > 0" [class.comment-first-reply]="index === 1" [class.action-reject]="comment.metadata && comment.metadata.action === 'reject'">
    <header>
      <span class="comment-author-avatar">
        @if (comment.user.userType == UserType.AgillicAdvisor) {
        <mat-icon style="vertical-align: middle;">store</mat-icon>
        } @else if (comment.user.userType == UserType.ActiveDirectory) {
        <mat-icon style="vertical-align: middle;">apartment</mat-icon>
        }
      </span>
      <span class="comment-author">
        {{ comment.user.displayName }}
      </span>
      <time class="comment-time" [attr.datetime]="comment.createdAt.toISOString()">{{ comment.createdAt | dfnsFormat: 'dd.MM.yyyy \'kl.\' HH:mm'  }}</time>
    </header>
    @if (comment.metadata && comment.metadata.action === 'reject') {

    <p class="comment-content">
      <strong>Udsendelsen blev afvist.</strong>
      @if (comment.message) {
      <br /><br />
      Kommentar: <i>{{ comment.message }}</i>
      }

    </p>
    } @else {
    <p class="comment-content">{{ comment.message }}</p>
    }
  </article>
</ng-template>

<div class="comment-threads">
  @if (threads$ | async; as threads) {
  @for (thread of threads; track thread; let threadOdd = $odd) {
  <div #commentThreads [attr.data-thread-id]="thread.id" class="comment-thread" [class.odd]="threadOdd" [class.thread-resolved]="thread.resolvedAt" [class.thread-unread]="thread.hasUnread">
    @for(comment of thread.comments; track comment; let commentOdd = $odd; let i = $index) {
    <ng-container *ngTemplateOutlet="commentPartial; context: { $implicit: comment, index: i }"></ng-container>
    }
    <div class="comment-thread-actions">
      <app-comment-input (submit)="onReply($event, thread.id)"></app-comment-input>

    </div>

  </div>
  }
  }
  <div>
    @if (threads$ | async; as threads) {
    @if (threads.length == 0) {
    <app-comment-input activationIcon="add_comment" activationLabel="Opret ny tråd" (submit)="onThread($event)"></app-comment-input>
    }
    }

  </div>
</div>
